import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Spin,
  Typography,
  Layout,
  message,
  Divider,
  Grid,
  Space,
} from 'antd';
import styled from 'styled-components';
import { SearchOutlined } from '@ant-design/icons';
import { onError } from 'utils/handlers';
import { DATETIME_FRONTEND_FORMAT, formatReceived } from 'utils/formatValues';
import { getReciboPorFolio, getRecibosPDF } from 'api/recaudacion/recibos';
import ModalLogin from 'views/Recaudacion/RegistroDePagos/ModalLogin';
import Previewer from 'components/Previewer';
import toCurrency from 'utils/toCurrency';
import { useQueryMultiple } from 'hooks/useQuery';
import { useHistory } from 'react-router';
import { capitalize, toUpper } from 'utils/normalizers';

const ENV_NAME = process.env.REACT_APP_ENV_NAME || 'migob';
// eslint-disable-next-line import/no-dynamic-require
const bg = require(`../../assets/${ENV_NAME}/bg.png`);

const BusquedaDeRecibos = () => {
  const history = useHistory();

  // eslint-disable-next-line max-len
  const { folio, referencia_de_seguridad } = useQueryMultiple(['folio', 'referencia_de_seguridad', 'other_param']);

  const screens = Grid.useBreakpoint();
  const [form] = Form.useForm();
  const [recibo, setRecibo] = useState();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visiblePreview, setVisiblePreview] = useState(false);
  const [base64, setBase64] = useState();

  const onFinish = async (_folio, _referencia_de_seguridad) => {
    try {
      setLoading(true);
      await form.validateFields();
      const params = form.getFieldsValue();
      if (params.id) {
        params.id = parseInt(params.id, 10);
      }
      if (_folio) {
        params.folio = _folio;
      }
      if (_referencia_de_seguridad) {
        params.referencia_de_seguridad = _referencia_de_seguridad;
      }
      if (params.referencia_de_seguridad
        && !(params.id || params.folio || params.folio_de_facturacion)) {
        message.warn('Ingrese al menos un campo adicional a la referencia de seguridad');
      } else {
        const _recibo = await getReciboPorFolio(params);
        if (_recibo) {
          setRecibo(formatReceived(_recibo));
          form.resetFields();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    if (folio) {
      form.setFieldsValue({ folio, referencia_de_seguridad });
      onFinish(...folio, ...referencia_de_seguridad);
    }
  }, []);

  const loginCallback = async (credentials) => {
    setLoading(true);
    const pdf = await getRecibosPDF([recibo.id], credentials.access);
    if (pdf) {
      setBase64(pdf.base64);
      setVisiblePreview(true);
    }
    setLoading(false);
  };

  const onCancel = () => {
    form.resetFields();
    setRecibo();
    setBase64();
    history.replace({
      search: '',
    });
  };
  const accentColor = process.env.REACT_APP_ENV_NAME === 'oaxaca' ? '#60212E' : '#55283e';

  return (
    <Spin spinning={loading} tip="Cargando...">
      <Content style={{ backgroundPosition: screens.md ? 'center 0' : '' }}>
        <Row justify="center" align="middle" style={{ height: '100vh' }}>
          <Card xs={22} sm={22} md={18} lg={14} xl={12} style={{ height: 'auto' }}>
            <CardHeader>
              <Typography.Title level={4}>
                {`${recibo ? 'Información' : 'Búsqueda'} de Recibo`}
              </Typography.Title>
            </CardHeader>
            <CardContent style={{ paddingLeft: screens.md ? '10vw' : 15, paddingRight: screens.md ? '10vw' : 15 }}>
              {recibo ? (
                <Row justify="space-between" className="info">
                  <Col span={11}>
                    <Label>Folio:</Label>
                    <Value>{recibo.folio}</Value>
                  </Col>
                  <Col span={11} style={{ textAlign: 'right' }}>
                    <Label>Fecha de Cobro:</Label>
                    <Value>{recibo.fecha_de_creacion.format(DATETIME_FRONTEND_FORMAT)}</Value>
                  </Col>
                  {screens.md && <Divider />}
                  <Col span={24}>
                    <Label>Unidad Recaudadora:</Label>
                    <Value>{recibo.unidad_de_recaudacion}</Value>
                  </Col>
                  {screens.md && <Divider />}
                  <Col span={11}>
                    <Label>Facturado:</Label>
                    <Value>{recibo.facturado ? 'Si' : 'No'}</Value>
                  </Col>
                  {screens.md && <Divider type="vertical" />}
                  <Col span={11} style={{ textAlign: 'right' }}>
                    <Label>Padrón:</Label>
                    <Value>{recibo.tipo_padron}</Value>
                  </Col>
                  <Col span={11}>
                    <Label>Estado:</Label>
                    <Value>{recibo.estados_globales}</Value>
                  </Col>
                  <Col span={11} style={{ textAlign: 'right' }}>
                    <Label>Importe Total:</Label>
                    <Value style={{ fontSize: 32 }}>{toCurrency(recibo.importe_total)}</Value>
                  </Col>
                  <Space style={{ margin: '20px auto' }} size={20}>
                    <Button
                      style={{
                        borderColor: accentColor,
                        borderRadius: 8,
                        padding: '0 10px',
                      }}
                      onClick={onCancel}
                    >
                      Buscar otro
                    </Button>
                    <Button
                      style={{
                        color: '#FFFFFF',
                        backgroundColor: accentColor,
                        borderRadius: 8,
                        padding: '0 10px',
                      }}
                      onClick={() => (base64 ? setVisiblePreview(true) : setVisible(true))}
                    >
                      Detalle Completo
                    </Button>
                  </Space>
                  <br />
                </Row>
              ) : (
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={() => onFinish()}
                >
                  <Row gutter={[10, 10]}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="Transacción" name="id" normalize={capitalize}>
                        <Input allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item label="Folio" name="folio" normalize={toUpper}>
                        <Input allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        label="Folio Facturación"
                        name="folio_de_facturacion"
                        normalize={toUpper}
                      >
                        <Input allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24}>
                      <Form.Item
                        label="Referencia de impresión"
                        name="referencia_de_seguridad"
                        tooltip="Referencia del Recibo"
                      >
                        <Input allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item>
                        <Button htmlType="submit" block icon={<SearchOutlined />}>
                          Buscar
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              )}
            </CardContent>
          </Card>
        </Row>
      </Content>
      <ModalLogin
        setVisible={setVisible}
        visible={visible}
        callback={loginCallback}
      />
      <Previewer
        visible={visiblePreview}
        setVisible={setVisiblePreview}
        base64={base64}
      />
    </Spin>
  );
};

const Content = styled(Layout.Content)`
  background-size: cover;
  background-image: url(${bg});
  min-height: 100vh;
`;

const CardHeader = styled.div`
  background-color: ${process.env.REACT_APP_ENV_NAME === 'oaxaca' ? '#79898F' : '#5D575B'};
  padding: 15px 0;
  text-align: center;
  .ant-typography {
    color: #FFFFFF;
  }
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

const Card = styled(Col)`
  background-color: #FFFFFF;
  border-radius: 8px;
`;

const CardContent = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  .info .ant-col {
    margin: 10px 0;
  }
  .ant-divider {
    margin: 0;
    border-top: 1px solid #DDDDDD;
  }
  .ant-divider-vertical {
    border-left: 1px solid #DDDDDD;
    height: calc(4em - 10px);
    margin: 5px;
  }
`;

const Label = styled(Typography.Text)`
  color: #8D8D8D;
  size: 13px;
  display: block;
`;

const Value = styled(Typography.Text)`
  color: #000000;
  size: 15px;
`;

export default BusquedaDeRecibos;
